import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const EverlastingGospelSection = () => {
    return (
        <section className="relative py-16 px-4 md:px-8 overflow-hidden">
            {/* Background decorative glow */}
            {/* <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[20px] h-[20px] rounded-full bg-blue-200/40 blur-[10px]" />
                <div className="absolute bottom-0 left-1/4 w-[10px] h-[10px] rounded-full bg-blue-100/50 blur-[10px]" />
                <div className="absolute bottom-0 right-1/4 w-[10px] h-[10px] rounded-full bg-indigo-100/50 blur-[10px]" />
            </div> */}

            <div className="relative max-w-4xl mx-auto flex flex-col items-center text-center gap-10">

                {/* Header Label */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                    className="inline-flex items-center gap-4"
                >
                    <span className="h-[1px] w-10 bg-blue-500" />
                    <span className="text-blue-600 font-bold text-[10px] tracking-[0.45em] uppercase">
                        The Everlasting Gospel

                    </span>
                    <span className="h-[1px] w-10 bg-blue-500" />
                </motion.div>

                {/* Main Title */}
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.1 }}
                    className="space-y-4"
                >
                    <h2 className="text-5xl md:text-8xl font-black text-stone-900 tracking-tighter leading-none uppercase">
                        Read The{" "}
                        <span className="text-blue-600 italic">Word.</span>
                    </h2>
                    <p className="text-stone-500 text-base md:text-xl font-medium leading-relaxed max-w-2xl mx-auto">
                        Get yourself a copy of the Everlasting Gospel of Leader Olumba
                        Olumba Obu, The Sole Spiritual Head of the Universe.
                    </p>
                </motion.div>

                {/* Book Image — centred, slanted fan effect via CSS */}
                <motion.div
                    initial={{ opacity: 0, scale: 0.92, y: 40 }}
                    whileInView={{ opacity: 1, scale: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 1, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
                    className="relative w-full max-w-[720px] mx-auto"
                >
                    {/* Glow behind image */}
                    <div className="absolute inset-0 rounded-3xl bg-blue-100/10 blur-3xl scale-90 translate-y-6" />

                    <img
                        src="/EVG Covers.png"
                        alt="Everlasting Gospel Books"
                        className="relative w-full h-auto object-contain"
                    />
                </motion.div>

                {/* Action Buttons */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.35 }}
                    className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full"
                >
                    <Link
                        to="/EGC"
                        onClick={() => window.scrollTo(0, 0)}
                        className="group relative inline-flex items-center gap-3 bg-blue-600 hover:bg-blue-500 text-white px-10 py-5 rounded-full text-xs font-black tracking-[0.2em] uppercase transition-all duration-300 shadow-[0_0_30px_rgba(37,99,235,0.4)] hover:shadow-[0_0_40px_rgba(37,99,235,0.6)] w-full sm:w-auto justify-center"
                    >
                        See More
                        <span className="group-hover:translate-x-1 transition-transform duration-300">→</span>
                    </Link>

                    <a
                        href="https://bcs-egc.org"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group inline-flex items-center gap-3 border border-stone-300 hover:border-blue-600 bg-white hover:bg-blue-50 text-stone-900 px-10 py-5 rounded-full text-xs font-black tracking-[0.2em] uppercase transition-all duration-300 shadow-sm w-full sm:w-auto justify-center"
                    >
                        <svg
                            className="w-4 h-4 text-blue-400"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                        >
                            <path d="M3 20.5v-17c0-.83.94-1.3 1.6-.8l14 8.5c.6.36.6 1.24 0 1.6l-14 8.5c-.66.5-1.6.03-1.6-.8z" />
                        </svg>
                        Get The App
                    </a>
                </motion.div>
            </div>
        </section>
    );
};

export default EverlastingGospelSection;
